const typeFilters = {
  Phones: 'Mobile Phones',
  Laptops: 'Laptops and Desktops',
  Monitors: 'Monitors',
  Accessories: 'Accessories',
  Consoles: 'Gaming',
};

export default typeFilters;
